module.exports = __webpack_public_path__ + "img/over-2.a1f8b45b.png";